module.exports = __webpack_public_path__ + "static/media/coffee.d079df6b.png";